"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TAX_REFUND = exports.SUPPORT = exports.RETIREMENT = exports.OUTSIDE_CONTRIBUTOR = exports.OTHER = exports.RESIDUALS_ROYALTIES = exports.INVESTMENT = exports.GOVERNMENT = exports.EMPLOYEE = exports.BUSINESS = void 0;
exports.BUSINESS = "business";
exports.EMPLOYEE = "employee"; // From: EMPLOYMENT

exports.GOVERNMENT = "government";
exports.INVESTMENT = "investment";
exports.RESIDUALS_ROYALTIES = "residualsRoyalties";
exports.OTHER = "other";
exports.OUTSIDE_CONTRIBUTOR = "outsideContributor";
exports.RETIREMENT = "retirement";
exports.SUPPORT = "support"; //special income source type that's only used to record already spent tax returns for the current year

exports.TAX_REFUND = "taxRefund";